import React from "react";

const Contact = () => {
  return (
    <main>
      {/* breadcrumb start */}
      <section className="page-title-wrapper max-md:h-[200px] w-full h-[345px] animate__animated animate__fadeIn">
        <div className="theme-container mx-auto h-full">
          <div className="w-full h-full flex justify-center items-center">
            <h2 className="headline-default text-black max-md:text-white">
              Contact Us
            </h2>
          </div>
        </div>
      </section>
      {/* breadcrumb end */}

      {/* blog start  */}
      <div className="faq-page-wrapper lg:pt-[120px] pt-[60px]">
        <div className="theme-container mx-auto">
          <div className="grid sm:grid-cols-4 grid-cols-1 lg:gap-[30px] gap-5">
            <div
              style={{
                boxShadow:
                  "0px 4.4px 12px -1px rgba(19, 16, 34, 0.06), 0px 2px 6.4px -1px rgba(19, 16, 34, 0.03)",
              }}
              className="item w-full animate__animated animate__fadeIn"
            >
              <div className="w-full lg:h-[324px] h-[290px] relative overflow-hidden xl:bg-white bg-primary-50 rounded">
                <div className="flex justify-center">
                  <div>
                    <div className="mt-[50px] xl:mb-[90px] mb-10 flex justify-center relative z-10">
                      <span>
                        <svg
                          width={30}
                          height={41}
                          viewBox="0 0 30 41"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.125 39.0625C9.0625 33.9844 0 21.875 0 15C0 6.71875 6.64062 0 15 0C23.2812 0 30 6.71875 30 15C30 21.875 20.8594 33.9844 16.7969 39.0625C15.8594 40.2344 14.0625 40.2344 13.125 39.0625ZM15 20C17.7344 20 20 17.8125 20 15C20 12.2656 17.7344 10 15 10C12.1875 10 10 12.2656 10 15C10 17.8125 12.1875 20 15 20Z"
                            fill="#028835"
                          />
                        </svg>
                      </span>
                    </div>
                    <p className="sm:text-[30px] font-semibold spline-sans sm:leading-[36px] text-2xl text-center text-primary-900 mb-3">
                      Address
                    </p>
                    <p className="text-base leading-[27px] px-8 text-primary-100 text-center">
                      Office No. 1, Bidla Sons Tower, Ajmer Road, Teachers Colony, Rajasthan – 302021
                    </p>
                    <div className="w-[300px] h-[300px] rounded-full bg-[#f5f5f5] absolute left-[0px] bottom-[174px] xl:block hidden" />
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                boxShadow:
                  "0px 4.4px 12px -1px rgba(19, 16, 34, 0.06), 0px 2px 6.4px -1px rgba(19, 16, 34, 0.03)",
              }}
              className="item w-full animate__animated animate__fadeIn"
            >
              <div className="w-full lg:h-[324px] h-[290px] relative overflow-hidden xl:bg-white bg-primary-50 rounded">
                <div className="flex justify-center">
                  <div>
                    <div className="mt-[50px] xl:mb-[90px] mb-10 flex justify-center relative z-10">
                      <span>
                        <svg
                          width={40}
                          height={30}
                          viewBox="0 0 40 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M36.25 0C38.2812 0 40 1.71875 40 3.75C40 5 39.375 6.09375 38.4375 6.79688L21.4844 19.5312C20.5469 20.2344 19.375 20.2344 18.4375 19.5312L1.48438 6.79688C0.546875 6.09375 0 5 0 3.75C0 1.71875 1.64062 0 3.75 0H36.25ZM16.9531 21.5625C18.75 22.8906 21.1719 22.8906 22.9688 21.5625L40 8.75V25C40 27.8125 37.7344 30 35 30H5C2.1875 30 0 27.8125 0 25V8.75L16.9531 21.5625Z"
                            fill="#028835"
                          />
                        </svg>
                      </span>
                    </div>
                    <p className="sm:text-[30px] font-semibold spline-sans sm:leading-[36px] text-2xl text-center text-primary-900 mb-3">
                      E-mail
                    </p>
                    <p className="text-base leading-[27px] text-primary-100 text-center">
                      info@oneclickdoctor.in
                    </p>
                    <div className="w-[300px] h-[300px] rounded-full bg-[#f5f5f5] absolute left-[0px] bottom-[174px] xl:block hidden" />
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                boxShadow:
                  "0px 4.4px 12px -1px rgba(19, 16, 34, 0.06), 0px 2px 6.4px -1px rgba(19, 16, 34, 0.03)",
              }}
              className="item w-full animate__animated animate__fadeIn"
            >
              <div className="w-full lg:h-[324px] h-[290px] relative overflow-hidden xl:bg-white bg-primary-50 rounded">
                <div className="flex justify-center">
                  <div>
                    <div className="mt-[50px] xl:mb-[90px] mb-10 flex justify-center relative z-10">
                      <span>
                        <svg
                          width={41}
                          height={42}
                          viewBox="0 0 41 42"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M39.9219 31.2344L38.0469 39.125C37.8125 40.2969 36.875 41.0781 35.7031 41.0781C16.0156 41 0 24.9844 0 5.29688C0 4.125 0.703125 3.1875 1.875 2.95312L9.76562 1.07812C10.8594 0.84375 12.0312 1.46875 12.5 2.48438L16.1719 11C16.5625 12.0156 16.3281 13.1875 15.4688 13.8125L11.25 17.25C13.9062 22.6406 18.2812 27.0156 23.75 29.6719L27.1875 25.4531C27.8125 24.6719 28.9844 24.3594 30 24.75L38.5156 28.4219C39.5312 28.9688 40.1562 30.1406 39.9219 31.2344Z"
                            fill="#028835"
                          />
                        </svg>
                      </span>
                    </div>
                    <p className="sm:text-[30px] font-semibold spline-sans sm:leading-[36px] text-2xl text-center text-primary-900 mb-3">
                      Call us
                    </p>
                    <p className="text-base leading-[27px] text-primary-100 text-center">
                      +91 7877410039
                    </p>
                    <div className="w-[300px] h-[300px] rounded-full bg-[#f5f5f5] absolute left-[0px] bottom-[174px] xl:block hidden" />
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                boxShadow:
                  "0px 4.4px 12px -1px rgba(19, 16, 34, 0.06), 0px 2px 6.4px -1px rgba(19, 16, 34, 0.03)",
              }}
              className="item w-full animate__animated animate__fadeIn"
            >
              <div className="w-full lg:h-[324px] h-[290px] relative overflow-hidden xl:bg-white bg-primary-50 rounded">
                <div className="flex justify-center">
                  <div>
                    <div className="mt-[50px] xl:mb-[90px] mb-10 flex justify-center relative z-10">
                      <span>
                        <svg
                          width="42px"
                          height="42px"
                          viewBox="0 0 20 20"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                        >
                          <title>whatsapp [#128]</title>
                          <desc>Created with Sketch.</desc>
                          <defs></defs>
                          <g
                            id="Page-1"
                            stroke="none"
                            strokeWidth={1}
                            fill="none"
                            fillRule="evenodd"
                          >
                            <g
                              id="Dribbble-Light-Preview"
                              transform="translate(-300.000000, -7599.000000)"
                              fill="#028835"
                            >
                              <g
                                id="icons"
                                transform="translate(56.000000, 160.000000)"
                              >
                                <path
                                  d="M259.821,7453.12124 C259.58,7453.80344 258.622,7454.36761 257.858,7454.53266 C257.335,7454.64369 256.653,7454.73172 254.355,7453.77943 C251.774,7452.71011 248.19,7448.90097 248.19,7446.36621 C248.19,7445.07582 248.934,7443.57337 250.235,7443.57337 C250.861,7443.57337 250.999,7443.58538 251.205,7444.07952 C251.446,7444.6617 252.034,7446.09613 252.104,7446.24317 C252.393,7446.84635 251.81,7447.19946 251.387,7447.72462 C251.252,7447.88266 251.099,7448.05372 251.27,7448.3478 C251.44,7448.63589 252.028,7449.59418 252.892,7450.36341 C254.008,7451.35771 254.913,7451.6748 255.237,7451.80984 C255.478,7451.90987 255.766,7451.88687 255.942,7451.69881 C256.165,7451.45774 256.442,7451.05762 256.724,7450.6635 C256.923,7450.38141 257.176,7450.3464 257.441,7450.44643 C257.62,7450.50845 259.895,7451.56477 259.991,7451.73382 C260.062,7451.85686 260.062,7452.43903 259.821,7453.12124 M254.002,7439 L253.997,7439 L253.997,7439 C248.484,7439 244,7443.48535 244,7449 C244,7451.18666 244.705,7453.21526 245.904,7454.86076 L244.658,7458.57687 L248.501,7457.3485 C250.082,7458.39482 251.969,7459 254.002,7459 C259.515,7459 264,7454.51465 264,7449 C264,7443.48535 259.515,7439 254.002,7439"
                                  id="whatsapp-[#128]"
                                ></path>
                              </g>
                            </g>
                          </g>
                        </svg>
                      </span>
                    </div>
                    <p className="sm:text-[30px] font-semibold spline-sans sm:leading-[36px] text-2xl text-center text-primary-900 mb-3">
                      Care Whatsapp
                    </p>
                    <p className="text-base leading-[27px] text-primary-100 text-center">
                       +91 7877410039
                    </p>
                    <div className="w-[300px] h-[300px] rounded-full bg-[#f5f5f5] absolute left-[0px] bottom-[174px] xl:block hidden" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section className="w-full xl:-mt-[80px] mt-[60px]">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d28463.13855801361!2d75.716856056378!3d26.906912316820453!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1s3%2F227%2C%20G-1%2C%20C%20Block%2C%20Vaishali%20Nagar%2C%20Jaipur%2C%20Rajasthan%2C%20302021!5e0!3m2!1sen!2sin!4v1750848741532!5m2!1sen!2sin"
            className="w-full"
            height={450}
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </section>
      </div>

      {/* blog end  */}
    </main>
  );
};

export default Contact;
